"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const template_parser_1 = require("@osmosys/template-parser");
const logger_1 = require("@osmosys/logger");
exports.findAndReplace = ({ el, log, parentTimestamp, step, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let newEl = el;
    log('info', {
        message: (react_1.default.createElement(react_1.default.Fragment, null,
            "Finding ",
            react_1.default.createElement("code", null, step.textToFind),
            " and replacing with",
            ' ',
            react_1.default.createElement("code", null, step.textToReplace),
            "...")),
        parentTimestamp,
        plainTextMessage: `Finding "${step.textToFind}" and replacing with "${step.textToReplace}".`,
    });
    let str = template_parser_1.elToHtmlString(newEl);
    if (!str) {
        log('warn', {
            message: 'Warning: No content provided. The conversion will continue, but you may not see any output.',
            parentTimestamp,
            plainTextMessage: 'Warning: No content provided. The conversion will continue, but you may not see any output.',
        });
    }
    const re = new RegExp(step.textToFind, 'g');
    const matches = str.match(re);
    if (!matches || matches.length === 0) {
        log('warn', {
            message: (react_1.default.createElement(react_1.default.Fragment, null,
                "Found no matches for ",
                react_1.default.createElement("code", null, step.textToFind),
                ".")),
            parentTimestamp,
            plainTextMessage: `Found no matches for "${step.textToFind}".`,
        });
        return newEl;
    }
    log('debug', {
        message: (react_1.default.createElement(react_1.default.Fragment, null,
            "Found ",
            matches.length,
            " match",
            matches.length === 1 ? '' : 'es',
            " for ",
            react_1.default.createElement("code", null, step.textToFind),
            ". Replacing with ",
            react_1.default.createElement("code", null, step.textToReplace),
            "...")),
        parentTimestamp,
        plainTextMessage: `Found ${matches.length} match${matches.length === 1 ? '' : 'es'} for "${step.textToFind}". Replacing with "${step.textToReplace}"...`,
    });
    try {
        str = str.replace(re, step.textToReplace);
        newEl = template_parser_1.stringToEl(str).content;
    }
    catch (e) {
        logger_1.logger.error('Failed to findAndReplace:');
        logger_1.logger.error(e);
        log('error', {
            message: (react_1.default.createElement(react_1.default.Fragment, null,
                "Failed to replace",
                react_1.default.createElement("code", null, step.textToFind),
                " with ",
                react_1.default.createElement("code", null, step.textToReplace),
                ".")),
            parentTimestamp,
            plainTextMessage: `Failed to replace "${step.textToFind}" with "${step.textToReplace}"`,
        });
        return newEl;
    }
    log('success', {
        message: (react_1.default.createElement(react_1.default.Fragment, null,
            "Replaced ",
            matches.length,
            " match",
            matches.length === 1 ? '' : 'es',
            " of ",
            react_1.default.createElement("code", null, step.textToFind),
            ' ',
            "with ",
            react_1.default.createElement("code", null, step.textToReplace),
            ".")),
        parentTimestamp,
        plainTextMessage: `Found ${matches.length} match${matches.length === 1 ? '' : 'es'} for "${step.textToFind}"`,
    });
    return newEl;
});
// Below is taken from: https://github.com/yellowbrim/osmosys/commit/54953b1394132884ea0c9b77a110324171a6c9e7
//
// if (da.type === 'findAndReplace') {
//   dispatch({
//     log: {
//       level: 'info',
//       message: (
//         <>
//           Finding <code>{da.textToFind}</code> and replacing with{' '}
//           <code>{da.textToFind}</code>...
//         </>
//       ),
//       parentTimestamp,
//       plainTextMessage: `Finding "${da.textToFind}" and replacing with "${da.textToReplace}".`,
//       timestamp: new Date(),
//     },
//     type: 'add',
//   });
//   let str = elToHtmlString(newEl);
//   const re = new RegExp(da.textToFind, 'g');
//   const matches = str.match(re);
//   if (!matches || matches.length === 0) {
//     dispatch({
//       log: {
//         level: 'warn',
//         message: (
//           <>
//             Found no matches for <code>{da.textToFind}</code>.
//           </>
//         ),
//         parentTimestamp,
//         plainTextMessage: `Found no matches for "${da.textToFind}".`,
//         timestamp: new Date(),
//       },
//       type: 'add',
//     });
//     return [...arr, new Date()];
//   }
//   dispatch({
//     log: {
//       level: 'debug',
//       message: (
//         <>
//           Found {matches.length} match{matches.length === 1 ? '' : 'es'} for{' '}
//           <code>{da.textToFind}</code>. Replacing...
//         </>
//       ),
//       parentTimestamp,
//       plainTextMessage: `Found ${matches.length} match${
//         matches.length === 1 ? '' : 'es'
//       } for "${da.textToFind}". Replacing...`,
//       timestamp: new Date(),
//     },
//     type: 'add',
//   });
//   try {
//     str = str.replace(re, da.textToReplace);
//     newEl = stringToEl(str).content;
//   } catch (e) {
//     logger.error(`Failed to findAndReplace:`);
//     logger.error(e);
//     dispatch({
//       log: {
//         level: 'error',
//         message: (
//           <>
//             Failed to replace
//             <code>{da.textToFind}</code> with{' '}
//             <code>{da.textToReplace}</code>.
//           </>
//         ),
//         parentTimestamp,
//         plainTextMessage: `Failed to replace "${da.textToReplace}" with "${da.textToFind}"`,
//         timestamp: new Date(),
//       },
//       type: 'add',
//     });
//     return [...arr, new Date()];
//   }
//   dispatch({
//     log: {
//       level: 'success',
//       message: (
//         <>
//           Replaced {matches.length} match{matches.length === 1 ? '' : 'es'}{' '}
//           of <code>{da.textToFind}</code> with{' '}
//           <code>{da.textToReplace}</code>.
//         </>
//       ),
//       parentTimestamp,
//       plainTextMessage: `Found ${matches.length} match${
//         matches.length === 1 ? '' : 'es'
//       } for "${da.textToFind}"`,
//       timestamp: new Date(),
//     },
//     type: 'add',
//   });
//   return [...arr, new Date()];
// }
//# sourceMappingURL=findAndReplace.js.map